/**
 * @generated SignedSource<<3a1549436988f02c0ab0f54dc522ba64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FullPicker_account$data = {
  readonly default_full_time_minutes: number;
  readonly " $fragmentSpreads": FragmentRefs<"PlannerDatePickerHourStats_account" | "TimeOffEffortInputs_account">;
  readonly " $fragmentType": "FullPicker_account";
};
export type FullPicker_account$key = {
  readonly " $data"?: FullPicker_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"FullPicker_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FullPicker_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default_full_time_minutes",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PlannerDatePickerHourStats_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeOffEffortInputs_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "360d851f08485ca9bc32aa093bcaa243";

export default node;
